
import React from 'react';
import { Editor } from '@tiptap/react';
import { Heading1, Heading2 } from 'lucide-react';
import EditorButton from '../buttons/EditorButton';
import EditorButtonGroup from '../buttons/EditorButtonGroup';

interface HeadingButtonsProps {
  editor: Editor;
}

const HeadingButtons = ({ editor }: HeadingButtonsProps) => {
  return (
    <EditorButtonGroup>
      <EditorButton 
        onClick={() => editor.chain().focus().setParagraph().run()}
        isActive={editor.isActive('paragraph')}
        title="Paragraphe"
        icon={<span className="text-xs font-medium">P</span>}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().toggleHeading({ level: 1 }).run()}
        isActive={editor.isActive('heading', { level: 1 })}
        title="Titre 1"
        icon={<Heading1 className="h-4 w-4" />}
      />
      <EditorButton 
        onClick={() => editor.chain().focus().toggleHeading({ level: 2 }).run()}
        isActive={editor.isActive('heading', { level: 2 })}
        title="Titre 2"
        icon={<Heading2 className="h-4 w-4" />}
      />
    </EditorButtonGroup>
  );
};

export default HeadingButtons;
